import { useEffect, useRef, useState } from "react";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import MyInput from "../../Components/Myinput";
import Mytitle from "../../Components/Mytitle";
import MyButton from "../../Components/MyButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { useReactToPrint } from "react-to-print";
import { useSettings } from "../../context/SettingsContext";

function IncomeStatement() {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const printRef = useRef();
  const { settings } = useSettings();

  const fetchReport = async () => {
    setLoading(true);
    try {
      const { data } = await API.post("/income-statement", { from, to });
      setReport(data.data);
    } catch (error) {
      toast.error("خطأ في تحميل التقرير");
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };
  useEffect(() => {
  const today = new Date();

  // أول يوم في الشهر الحالي
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  // آخر يوم في الشهر الحالي
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  // نحول التاريخ إلى صيغة YYYY-MM-DD بدون UTC
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  setFrom(formatDate(firstDay));
  setTo(formatDate(lastDay));
}, []);

  return (
    <>
      <div className="income-statement-container">
        <Mytitle title="تقرير قائمة الدخل" className="no-print" />

        <div className="filters row g-3 mb-4 no-print">
          <div className="col-md-3">
            <MyInput
              label="من"
              type="date"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              dontShowDay={true}
            />
          </div>
          <div className="col-md-3">
            <MyInput
              label="إلى"
              type="date"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              dontShowDay={true}
            />
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <MyButton
              text={loading ? "جار التحميل..." : "عرض التقرير"}
              loading={loading}
              onClick={fetchReport}
            />
          </div>
        </div>
        <div className={`no-print align-self-end mb-3 no-print`}>
          <button className="btn btn-outline-info" onClick={handlePrint}>
            <FontAwesomeIcon icon={faPrint} />
          </button>
        </div>
        <div className="print-header ">
          <div className="d-flex justify-content-between align-items-center mb-3">
            {/* <img src={Logo} alt="Logo" width={80} /> */}
            <h2>تقرير قائمة الدخل</h2>
            {settings?.head_company_logo == 1 && (
              <img
                src={settings?.company_logo}
                alt="شعار الشركة"
                style={{
                  width: "80px",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />
            )}
          </div>
          <div className="print-header-section  ">
            {settings?.head_company_name == 1 && (
              <div>
                {" "}
                <strong>اسم الشركة </strong>: {settings?.company_name || "--"}
              </div>
            )}
            {settings?.head_invoice_address == 1 && (
              <div className="">
                <strong>العنوان </strong>: {settings?.company_address || "--"}
              </div>
            )}
          </div>

          <div className="print-header-section center"></div>

          <div className="print-header-section">
            <div>
              {" "}
              <strong>الهاتف</strong> : {settings?.company_phone || "--"}
            </div>
            <p className="mt-2">
              <strong>تاريخ الطباعة</strong>:{" "}
              {new Date().toLocaleString("ar-EG")}
            </p>
          </div>
        </div>
        {report && (
          <>
            <div className="report-card shadow-sm bg-white p-4 rounded">
              <h5 className="only-print">قائمة الدخل</h5>
              <h5 className="mb-3 text-center">
                من {report.from} إلى {report.to}
              </h5>
              <div className="report-row">
                <span>الإيرادات</span>
                <strong>{report.invoices.total}</strong>
              </div>
              <div className="report-row">
                <span>تكلفة الخدمات</span>
                <strong>
                  {report.invoices.total - report.invoices.total_win}
                </strong>
              </div>
              <div className="report-row">
                <span>المصروفات</span>
                <strong>{report.minvoices.total}</strong>
              </div>
              <div className="report-row">
                <span>المرتبات</span>
                <strong>{report.salary.total}</strong>
              </div>
              <div className="report-row net pt-2 mt-2">
                <span>صافي الربح</span>
                <strong>{report.net_income}</strong>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="print-footers only-print py-4">
        <div className="print-footer-section right">
          {settings?.foot_tax_number == 1 && (
            <div>
              <strong>الرقم الضريبي</strong>:{" "}
              {settings?.company_tax_number || "--"}
            </div>
          )}
          {settings?.foot_company_commercial == 1 && (
            <div className="fw-medium">
              <strong>السجل التجاري</strong>:
              {settings?.company_commercial || "--"}{" "}
            </div>
          )}
        </div>

        <div className="print-footer-section center">
          {settings?.foot_company_seal == 1 && (
            <div className="print-footer-section center">
              <img
                src={settings?.company_seal}
                alt="ختم الشركة"
                style={{
                  width: "80px",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />{" "}
            </div>
          )}
        </div>

        <div className="print-footer-section left">
          {settings?.foot_company_website == 1 && (
            <div>
              <strong>الموقع الإلكتروني</strong>:
              {settings?.company_website || "https://www.facebook.com/"}{" "}
            </div>
          )}
          {settings?.foot_company_email == 1 && (
            <div>
              <strong>البريد الإلكتروني</strong>:{" "}
              {settings?.company_email || "exampel@info.com"}{" "}
            </div>
          )}
        </div>
        <div className="text-center mt-2" style={{ height: "0px" }}>
          بوابات الأعمال الدولية © {new Date().getFullYear()} -{" "}
          <span>www.ibgates.com</span>
        </div>
      </div>
    </>
  );
}

export default IncomeStatement;
